import React, { Component } from 'react'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import Notes from '../../../components/scheduleRepair/Notes'
import Schedules from '../../../components/scheduleRepair/Schedules'
import Attachments from '../../../components/scheduleRepair/Attachments'
import { actions } from '../../../redux/modules/jobFunctions/scheduleRepairActions'

const propTypes = {}

class ScheduleRepair extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditing: false
    }
  }

  componentWillMount() {
    const { jobId, fetchScheduleRepairAttachments } = this.props
    fetchScheduleRepairAttachments(jobId)
  }

  render() {
    const { jobId } = this.props

    return (
      <div>
        <Schedules jobId={jobId} />
        <div className="row p-4">
          <div className="col-md-12">
            <Notes jobId={jobId} />
          </div>
        </div>
        <div className="row p-4">
          <div className="col-md-12">
            <Attachments jobId={this.props.jobId} userId={this.props.user.userId} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ scheduleRepairActions, authentication }, ownProps) => ({
  scheduleRepairActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(actions, dispatch)
})

ScheduleRepair.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ScheduleRepair))



// WEBPACK FOOTER //
// ./src/containers/job/tasks/ScheduleRepair.js